import PropTypes from 'prop-types';
import React, { useState } from 'react';

import FilestackUploader from '@components/common/filestack_uploader/main';
import { TextWarningButton } from '@components/library/button/index';
import { WatermarkPositions, defaultWatermarkPostion } from '@components/shared/watermarks';

const Watermark = ({ scope, updateScope }) => {
  const [watermarkFilename, setWatermarkFilename] = useState(scope?.watermark_filename);
  const [watermarkUrl, setWatermarkUrl] = useState(scope?.watermark_url);

  return (
    <div className="watermark">
      {watermarkUrl ? (
        <>
          {/* don't show watermark positions until an image has been uploaded */}
          <div className="brandguide-modal__filestack-container--thumbnail">
            <div className="brandguide-modal__filestack-container--thumbnail-container watermark-container">
              <img alt={watermarkFilename || ''} className="brandguide-modal__filestack-container--thumbnail--image watermark-image" src={watermarkUrl} title={watermarkFilename || ''} />
            </div>
            <TextWarningButton
              icon="bff-trash"
              onClick={() => {
                setWatermarkFilename(null);
                setWatermarkUrl(null);
                // when remove the file, return to the defaultWatermarkPostion
                updateScope({ ...scope, watermark_gravity: defaultWatermarkPostion, watermark_filename: null, watermark_url: null });
              }}
            />
          </div>
          <WatermarkPositions gravity={scope?.watermark_gravity || undefined} onChange={(gravity) => updateScope({ ...scope, watermark_gravity: gravity })} />
        </>
      ) : (
        <FilestackUploader
          onSuccess={(files) => {
            const file = files.filesUploaded[0];
            setWatermarkFilename(file.filename);
            setWatermarkUrl(file.url);
            // when uploading a file, return to the defaultWatermarkPostion
            updateScope({ ...scope, watermark_gravity: defaultWatermarkPostion, watermark_filename: file.filename, watermark_url: file.url });
          }}
          options={{
            accept: ["image/png"],
            maxFiles: 1,
            maxSize: 5 * 1024 * 1024 // 5MB
          }}
          type="area"
        />
      )}
    </div>
  );
};

Watermark.propTypes = {
  scope: PropTypes.shape({}).isRequired,
  updateScope: PropTypes.func.isRequired
};

export default Watermark;
